/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host span.message {
  color: var(--warp-view-font-color, #404040);
  padding-left: 5px;
}
:host .hidden {
  color: transparent;
  font-size: 0;
  height: 0;
  overflow: hidden;
}
:host .loader {
  font-size: 10px;
  display: inline-block;
  text-indent: -9999em;
  width: 12px;
  height: 11px;
  border-radius: 50%;
  background: var(--warp-view-spinner-color, #ff9900);
  background: -moz-linear-gradient(left, var(--warp-view-spinner-color, #ff9900) 10%, rgba(0, 0, 0, 0) 42%);
  background: -webkit-linear-gradient(left, var(--warp-view-spinner-color, #ff9900) 10%, rgba(0, 0, 0, 0) 42%);
  background: -o-linear-gradient(left, var(--warp-view-spinner-color, #ff9900) 10%, rgba(0, 0, 0, 0) 42%);
  background: -ms-linear-gradient(left, var(--warp-view-spinner-color, #ff9900) 10%, rgba(0, 0, 0, 0) 42%);
  background: linear-gradient(to right, var(--warp-view-spinner-color, #ff9900) 10%, rgba(0, 0, 0, 0) 42%);
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
:host .loader:before {
  width: 50%;
  height: 50%;
  background: var(--warp-view-spinner-color, #ff9900);
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
:host .loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}